var map = {
	"./Coreweb.SliderBlock.js": 2107,
	"./Coreweb.StripBlock.js": 8546,
	"./Coreweb.Utilities.ImageScaling.js": 3033,
	"./Coreweb.map.js": 8015
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7384;